/* eslint-disable max-len */

"use strict";

const { isNullOrEmpty } = require("./utils.js");

const ProductUtils = {
  /**
   * Returns string needed for getting product data from PMD
   * Example full url where this is used: "https://test.nuskin.com/content/products/01/16/08/01160862/en.service.US.json"
   * @param {string} sku - ex. "01160862"
   * @returns tokenized sku - ex. "01/16/08/01160862"
   */
  getTokenizedSku: function(sku) {
    let { part1, part2, part3 } = this.getTokenizedSkuParts(sku);
    return `${part1}/${part2}/${part3}/${sku}`;
  },

  /**
   * Returns string parts needed for getting product data from PMD
   * @param {string} sku - ex. "01160862"
   * @returns {{ part1, part2, part3 }} tokenized sku parts - ex. { "part1": "01", "part2": "16", "part3": "08" }
   */
  getTokenizedSkuParts: function(sku) {
    let part1 = sku.substring(0, 2); // "01"
    let part2 = sku.substring(2, 4); // "11"
    let part3 = sku.substring(4, 6); // "11"
    return {
      part1,
      part2,
      part3
    };
  },

  /**
   * Applies a Base URL by prepending it to an existing URL when applicable
   * @param {string} url - ex. "content/..." or "http://test.nuskin.com/content/..."
   * @param {string} baseUrl - ex. "http://test.nuskin.com"
   * @returns {string} full url
   */
  applyBaseUrl: function(url, baseUrl) {
    let result = url;
    if (baseUrl.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }
    if (url.startsWith("/")) {
      result = `${baseUrl}${result}`;
    }
    return result.replace("http://", "https://");
  },

  mergeOrderTypes: function(previousOrderTypes, newOrderTypes) {
    // untrust previous order types
    const previousOrderTypesMapping = this.getOrderTypesMapping(previousOrderTypes, false);

    // trust new order types
    const newOrderTypesMapping = this.getOrderTypesMapping(newOrderTypes);

    return {
      ...previousOrderTypesMapping,
      ...newOrderTypesMapping
    };
  },
  
  getOrderTypesMapping: function(orderTypes, active = true) {
    if (isNullOrEmpty(orderTypes)) {
      return {};
    }
    const orderTypesMapping = {};
    if (Array.isArray(orderTypes)) {
      for (const orderType of orderTypes) {
        orderTypesMapping[orderType.toLowerCase()] = active;
      }
    } else {
      for (const orderType in orderTypes) {
        orderTypesMapping[orderType.toLowerCase()] = active;
      }
    }
    return orderTypesMapping;
  }
};

module.exports = ProductUtils;
